import tkTK from '../../date-picker/locale/tk_TK';
export default tkTK;
